import React, { useEffect, useState } from "react";

import { makeStyles } from "@material-ui/core/styles";
import "./MainLanding.css";
import "./mainlandingnew.css";
// import Grid from '@material-ui/core/Grid';
import { Typography } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import { Auth } from "aws-amplify";
import { Link } from "react-router-dom";
import Dashboard from "../GenAi/Dashboard";

import Backdrop from "@material-ui/core/Backdrop";
import Modal from "@material-ui/core/Modal";
import TextField from "@material-ui/core/TextField";
import { API } from "aws-amplify";
import { getEduvanceAiUsers, listEduvanceAITools } from "../../graphql/queries";

import Accordion from "@material-ui/core/Accordion";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

const useStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    position: "absolute",
    // width: '60vw',
    backgroundColor: "#a0a0a0",
    border: "2px solid #000",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
  root: {
    width: "100%",
    padding: "1rem 0",
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: theme.typography.fontWeightRegular,
  },
}));

const MainLandingnew = (props) => {
  const [expanded, setExpanded] = React.useState(false);

  const [showDashboard, setShowDashboard] = useState(false);

  const handleButtonClick = () => {
    setShowDashboard(true);
  };

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };
  const classes = useStyles();
  const [basicProjects, setBasicProjects] = useState("");
  const [advanceProjects, setAdvanceProjects] = useState("");
  const [currentCategory, setCurrentCategory] = useState("");
  const [isPremium, setIsPremium] = useState(
    localStorage.getItem("accountType"),
  );
  const [couponModalOpen, setCouponModalOpen] = useState(false);

  useEffect(() => {
    fetchValidity();
  }, []);

  async function fetchValidity() {
    var username = localStorage.getItem(
      "CognitoIdentityServiceProvider.29j70cln6jt05tfejrnii8d5d.LastAuthUser",
    );
    var userdata = localStorage.getItem(
      `CognitoIdentityServiceProvider.29j70cln6jt05tfejrnii8d5d.${username}.userData`,
    );
    var jsondata = JSON.parse(userdata);
    var emailid = `${username}//${
      jsondata["UserAttributes"][jsondata["UserAttributes"].length - 2]["Value"]
    }`;

    const apiData = await API.graphql({
      query: getEduvanceAiUsers,
      variables: { User: emailid },
    });
    // console.log("data " + JSON.stringify( apiData.data.getEduvanceAiUsers['expiry']));
    if (!apiData.data.getEduvanceAiUsers) {
      localStorage.setItem("validity", "free");

      localStorage.setItem("accountType", "Free");
    } else {
      if (new Date(apiData.data.getEduvanceAiUsers["expiry"]) > Date.now()) {
        // console.log("yeah baby");
        localStorage.setItem(
          "validity",
          apiData.data.getEduvanceAiUsers["expiry"],
        );
        setIsPremium(true);
        setIsPremium("Premium");
        localStorage.setItem("accountType", "Premium");
      } else {
        localStorage.setItem("validity", "free");
        localStorage.setItem("accountType", "Free");
        setIsPremium("Free");
        // console.log("bad babdy");
      }
    }
    // apiData.data.getEduvanceAiUsers.items.forEach(item => {
    //     console.log("item "+JSON.stringify(item));
    // })
  }
  const handlecouponModalOpen = () => {
    setCouponModalOpen(true);
  };

  const handleCouponModalClose = () => {
    setCouponModalOpen(false);
  };
  async function signOut() {
    try {
      await Auth.signOut({ global: true });
      window.location.reload();
    } catch (error) {
      // console.log('error signing out: ', error);
    }
  }
  const verifyCoupon = () => {
    var couponid = document.getElementById("couponid").value;
    var username = localStorage.getItem(
      "CognitoIdentityServiceProvider.29j70cln6jt05tfejrnii8d5d.LastAuthUser",
    );
    var userdata = localStorage.getItem(
      `CognitoIdentityServiceProvider.29j70cln6jt05tfejrnii8d5d.${username}.userData`,
    );
    var jsondata = JSON.parse(userdata);
    var data = `${username}//${
      jsondata["UserAttributes"][jsondata["UserAttributes"].length - 2]["Value"]
    }`;
    var xhr = new XMLHttpRequest();
    xhr.addEventListener("readystatechange", function () {
      if (this.readyState === 4) {
        // console.log(this.responseText);
        if (this.responseText === "Your account has been upgraded.") {
          alert("coupon successfully redeemed");
          setCouponModalOpen(false);
          window.location.reload();
        } else alert(this.responseText);
      }
    });
    xhr.open(
      "POST",
      `https://s2v68e8y9a.execute-api.ap-south-1.amazonaws.com/dev/coupon?coupon=${couponid}&type=redeem`,
    );
    xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
    xhr.send(data);
  };
  function downloadCSVFile(url, filename) {
    fetch(url)
      .then((response) => response.blob())
      .then((blob) => {
        const url = window.URL.createObjectURL(new Blob([blob]));
        const a = document.createElement("a");
        a.href = url;
        a.download = `${filename}.zip`;
        document.body.appendChild(a);
        a.click();
        a.remove();
      });
  }
  return (
    <>
      <Modal
        open={couponModalOpen}
        onClose={handleCouponModalClose}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        className={classes.modal}
        BackdropComponent={Backdrop}
      >
        <div className={classes.paper + " text-center"}>
          <TextField
            id="couponid"
            style={{ color: "black" }}
            placeholder="Enter Coupon"
          />
          <br></br>
          <br></br>
          <span>Please mail at contact@eduvance.in to get coupon.</span>
          <br></br>
          <Button
            variant="contained"
            color="primary"
            component="span"
            onClick={verifyCoupon}
          >
            SUBMIT
          </Button>
        </div>
      </Modal>

      <div className="mainbody-new">
        <div
          style={{
            position: "absolute",
            zIndex: "-1",
            top: "0",
            width: "100%",
          }}
        >
          <img
            id="backgroundmainimageoverlay"
            src="/assets/images/background/g7.mp4"
            alt="background-img"
            style={{
              filter: "opacity(0.2)",
              position: "fixed",
              zIndex: "-3",
              width: "100vw",
              height: "110vh",
              marginTop: "-10vh",
              overflow: "hidden",
            }}
          />
          <img
            style={{ zIndex: "-4" }}
            id="backgroundmainimage"
            src="/assets/images/background/MainBackground.png"
            alt="main-background-img"
          />
        </div>

        <div className="left-container">
          <div className="aitool-logo">
            <img
              src="/assets/images/AItool-logo.png"
              alt="logo"
              style={{ width: "15vw", marginLeft: "2rem" }}
            />
            {/* <img src="/assets/images/Eduvance_Logo.png" style={{ width: "15vw" }} /> */}
          </div>
          <div>{/* <h2>Eduvance AI</h2> */}</div>
          <div className="profile-info">
            <img
              src="/assets/images/icons/profile.png"
              alt="icon"
              style={{ width: "2.5rem", height: "2.5rem", marginRight: "1rem" }}
            />
            {/* <AccountCircleIcon style={{marginLeft:"1vw"}} /> */}
            {isPremium === "Premium" ? (
              <>
                <Typography className="license_font">
                  <h4>Premium User</h4>
                  <p>
                    Validity:{localStorage.getItem("validity").substring(3, 16)}
                  </p>
                </Typography>

                {/* <Typography className='license_font' style={{ fontSize: "1.5vw", paddingTop: "1.2vh" }} >Validity:{localStorage.getItem("validity").substring(3, 16)}</Typography> */}
              </>
            ) : (
              <>
                <Typography className="license_font">
                  Free User <br />
                  <a
                    href="#"
                    className="add_sign"
                    onClick={() => {
                      setCouponModalOpen(true);
                    }}
                  >
                    + Add Coupon
                  </a>
                </Typography>
              </>
            )}
            <div className="sign-out-btn">
              <p
                onClick={() => {
                  signOut();
                }}
              >
                Sign Out
              </p>
            </div>
          </div>
        </div>

        <div
          className="right-container"
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(2, 1fr)",
            gridGap: "50px",
            justifyContent: "center",
            margin: "2rem auto",
            width: "70vw",
          }}
        >
          {/* Machine Learning Modes Column */}
          <div className="column" style={{ flex: 1 }}>
            <div className="version-container">
              <img
                className="ml-img"
                src="./assets/images/generative-ai.jpg"
                alt="Generative AI"
              />
              <h3 style={{ fontWeight: "bold", zIndex: "19", color: "#fff" }}>
                Machine Learning
              </h3>
              <Link
                to="/basic"
                style={{ textDecoration: "none", zIndex: "19" }}
              >
                <div className="version">
                  <h2 style={{ fontSize: "1.5rem" }}>
                    Basic <br />
                    Mode
                  </h2>
                  <img
                    className="basic-image"
                    src="assets/images/icons/Basic.png"
                    alt="Basic Mode"
                  />
                </div>
              </Link>
              <Link
                to="/intermediate"
                style={{ textDecoration: "none", zIndex: "19" }}
              >
                <div className="version version2">
                  <h2 style={{ fontSize: "1.5rem" }}>
                    Intermediate <br />
                    Mode
                  </h2>
                  <img
                    className="basic-image"
                    src="assets/images/icons/Intermediate.png"
                    alt="Intermediate Mode"
                  />
                </div>
              </Link>
              <Link
                to="/advance"
                style={{ textDecoration: "none", zIndex: "19" }}
              >
                <div className="version version3">
                  <h2 style={{ fontSize: "1.5rem" }}>
                    Advanced <br />
                    Mode
                  </h2>
                  <img
                    className="advance-image"
                    src="assets/images/icons/Advance.png"
                    alt="Advanced Mode"
                  />
                </div>
              </Link>
            </div>
          </div>

          {/* Generative AI Column */}
          <div className="column" style={{ flex: 1, margin: "0 10px" }}>
            <div className="dataset-lists" style={{ marginBottom: "2rem" }}>
              <div style={{ marginBottom: "1rem" }}>
                <h3 style={{ textAlign: "center", fontWeight: "bold" }}>
                  Generative AI
                </h3>
                <img
                  src="assets/images/genai-home.jpg"
                  alt="Generative AI"
                  style={{
                    width: "100%",
                    height: "auto",
                    maxWidth: "100%",
                    objectFit: "cover",
                    borderRadius: "8px", // Optional: Adds a nice rounded corner effect
                  }}
                />
              </div>
              <div style={{ display: "flex", justifyContent: "center" }}>
                <Link to="/departments" style={{ textDecoration: "none" }}>
                  <button className="download-genai">Getting Started</button>
                </Link>
              </div>
              {showDashboard && <Dashboard />}
            </div>
          </div>
        </div>
        {/* Dataset Packages Column */}
        <div className="column" style={{ flex: 1, margin: "0 10px" }}>
          {/* Existing Dataset Section */}
          <div className="dataset-container">
            <div
              className="dataset-lists"
              style={{ margin: "2rem auto", width: "40%" }}
            >
              <h3 style={{ textAlign: "center", fontWeight: "bold" }}>
                Dataset Packages
              </h3>
              {/* Existing Accordion structure for dataset */}
              <div className={classes.root}>
                <Accordion
                  expanded={expanded === "panel0"}
                  onChange={handleChange("panel0")}
                  style={{
                    background:
                      "linear-gradient(176deg, rgb(164, 219, 255) 0%, rgb(184, 211, 218) 100%)",
                  }}
                >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel0a-content"
                    id="panel0a-header"
                  >
                    <Typography
                      style={{ fontWeight: "bold" }}
                      className={classes.heading}
                    >
                      Manufacturing
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <div style={{ width: "100%" }}>
                      <div className="inner-content-dataset">
                        <p style={{ color: "black", wordBreak: "break-word" }}>
                          Predictive Maintenance
                        </p>
                        <p
                          onClick={() => {
                            downloadCSVFile(
                              "https://enablar-code.s3.ap-south-1.amazonaws.com/Predictive+Maintenance.zip",
                              "Predictive Maintenance",
                            );
                          }}
                          className="download"
                        >
                          Download
                        </p>
                      </div>
                      <div className="inner-content-dataset">
                        <p style={{ color: "black", wordBreak: "break-word" }}>
                          Employee Productivity
                        </p>
                        <p
                          onClick={() => {
                            downloadCSVFile(
                              "https://enablar-code.s3.ap-south-1.amazonaws.com/Employee+Productivity.zip",
                              "Employee Productivity",
                            );
                          }}
                          className="download"
                        >
                          Download
                        </p>
                      </div>
                    </div>
                  </AccordionDetails>
                </Accordion>
                <Accordion
                  expanded={expanded === "panel1"}
                  onChange={handleChange("panel1")}
                  style={{
                    background:
                      "linear-gradient(176deg, rgb(164, 219, 255) 0%, rgb(184, 211, 218) 100%)",
                  }}
                >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                  >
                    <Typography
                      style={{ fontWeight: "bold" }}
                      className={classes.heading}
                    >
                      HR
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <div style={{ width: "100%" }}>
                      <div className="inner-content-dataset">
                        <p style={{ color: "black", wordBreak: "break-word" }}>
                          Employee Attrition
                        </p>
                        <p
                          onClick={() => {
                            downloadCSVFile(
                              "https://enablar-code.s3.ap-south-1.amazonaws.com/Employee+Attrition.zip",
                              "Employee Attrition",
                            );
                          }}
                          className="download"
                        >
                          Download
                        </p>
                      </div>
                    </div>
                  </AccordionDetails>
                </Accordion>
                <Accordion
                  expanded={expanded === "panel2"}
                  onChange={handleChange("panel2")}
                  style={{
                    background:
                      "linear-gradient(176deg, rgb(164, 219, 255) 0%, rgb(184, 211, 218) 100%)",
                  }}
                >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                  >
                    <Typography
                      style={{ fontWeight: "bold" }}
                      className={classes.heading}
                    >
                      Marketing
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <div style={{ width: "100%" }}>
                      <div className="inner-content-dataset">
                        <p style={{ color: "black", wordBreak: "break-word" }}>
                          Food Marketing
                        </p>
                        <p
                          onClick={() => {
                            downloadCSVFile(
                              "https://enablar-code.s3.ap-south-1.amazonaws.com/Food+Training.zip",
                              "Food Marketing",
                            );
                          }}
                          className="download"
                        >
                          Download
                        </p>
                      </div>
                    </div>
                  </AccordionDetails>
                </Accordion>
                <Accordion
                  expanded={expanded === "panel3"}
                  onChange={handleChange("panel3")}
                  style={{
                    background:
                      "linear-gradient(176deg, rgb(164, 219, 255) 0%, rgb(184, 211, 218) 100%)",
                  }}
                >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel2a-content"
                    id="panel2a-header"
                  >
                    <Typography
                      style={{ fontWeight: "bold" }}
                      className={classes.heading}
                    >
                      Sales Demand Forecasting
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <div style={{ width: "100%" }}>
                      <div className="inner-content-dataset">
                        <p style={{ color: "black", wordBreak: "break-word" }}>
                          Product Sales
                        </p>
                        <p
                          onClick={() => {
                            downloadCSVFile(
                              "https://enablar-code.s3.ap-south-1.amazonaws.com/Sales+Demand+Forecasting.zip",
                              "Product Sales",
                            );
                          }}
                          className="download"
                        >
                          Download
                        </p>
                      </div>
                    </div>
                  </AccordionDetails>
                </Accordion>

                <Accordion
                  expanded={expanded === "panel4"}
                  onChange={handleChange("panel4")}
                  style={{
                    background:
                      "linear-gradient(176deg, rgb(164, 219, 255) 0%, rgb(184, 211, 218) 100%)",
                  }}
                >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                  >
                    <Typography
                      style={{ fontWeight: "bold" }}
                      className={classes.heading}
                    >
                      Finance
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <div style={{ width: "100%" }}>
                      <div className="inner-content-dataset">
                        <p style={{ color: "black", wordBreak: "break-word" }}>
                          Fraud Detection
                        </p>
                        <p
                          onClick={() => {
                            downloadCSVFile(
                              "https://enablar-code.s3.ap-south-1.amazonaws.com/Fraud+detection+dataset.zip",
                              "Fraud Detection",
                            );
                          }}
                          className="download"
                        >
                          Download
                        </p>
                      </div>
                      <div className="inner-content-dataset">
                        <p style={{ color: "black", wordBreak: "break-word" }}>
                          Loan Eligibility
                        </p>
                        <p
                          onClick={() => {
                            downloadCSVFile(
                              "https://enablar-code.s3.ap-south-1.amazonaws.com/Loan+Eligibility.zip",
                              "Loan Eligibility",
                            );
                          }}
                          className="download"
                        >
                          Download
                        </p>
                      </div>
                    </div>
                  </AccordionDetails>
                </Accordion>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MainLandingnew;
